import script from "./maikajiluCopy.vue?vue&type=script&setup=true&lang=js"
export * from "./maikajiluCopy.vue?vue&type=script&setup=true&lang=js"

import "./maikajiluCopy.vue?vue&type=style&index=0&id=07f19d6d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07f19d6d"]])

export default __exports__